export default async ({ route, store, isDev }) => {
  if (!store.state.settings || !store.state.settings._uid) {
    const version = route.query._storyblok || isDev ? 'draft' : 'published';

    await store.dispatch('loadSettings', { version });
  }
}
